import React from "react";
import {createUseStyles, useTheme} from "react-jss";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {Theme} from "engage-client/theme";
import HostPlayerDisplay from "./HostPlayerDisplay";
import HostViewAll, {ViewAllType} from "./HostViewAll";


const useStyles = createUseStyles<Theme>((theme) => ({
    hotStreak: {
        width: 16,
        height: 26,
        paddingBottom: 4,
        marginRight:12
    },
    hostLongestStreak: {
        color: theme.accessoryPanel.dashBoard.averageTime.host.timeColor,
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        background: theme.accessoryPanel.dashBoard.averageTime.host.background,
        alignItems: "center",
        padding: 32,
        [theme.breakpoints.only("xs")] : {
            padding: 20
        },
        height: "100%",
        width: "33.33%",
        [theme.breakpoints.up("xxl")] : {
            padding: "5vh"
        }
    },
    hostTitle:{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        fontWeight: theme.accessoryPanel.dashBoard.simpleDashboard ? 700 : 400,
        color: theme.accessoryPanel.dashBoard.sectionTitleColor,
        minHeight: 36,
        [theme.breakpoints.up("xxl")] : {
            marginBottom: "2vh"
        }
    },
    playerNames: {
        width: "100%",
        alignSelf: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    streak: {
        color: theme.accessoryPanel.dashBoard.streak.streakNumberColor,
        position: "relative",
        width: 113,
        height: 157,
        [theme.breakpoints.down("md")] : {
            width: 100,
            height: 140,
            marginBottom: "0"
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: 20,
        [theme.breakpoints.up("xxl")] : {
            width: "11vh",
            height: "14vh",
            marginBottom: "2vh",
        }
    },
    streakImage: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    },
    streakNumber: {
        position: "absolute",
        bottom: 15,
        zIndex: 1,
        [theme.breakpoints.up("xxl")] : {
            bottom: "1.5vh"
        }
    },
    streakContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: 200,
        paddingRight: 10,
        [theme.breakpoints.down("lg")] : {
            paddingRight: 0,
            paddingBottom: 10,
            width: 200
        },
        [theme.breakpoints.up("xxl")] : {
            paddingRight: "1vw",
            paddingBottom: 0,
            width: "12vw"
        }
    }
}));

export type StreakProps = {
    streak:number
}

export default function Streak({streak}:StreakProps) {
    const classes = useStyles();
    const theme:Theme = useTheme();
    return (
        <div className={classes.streakContainer}>
            <div className={classes.streak}>
                <img className={classes.streakImage} src={theme.accessoryPanel.dashBoard.streak.fireSVGPath} alt="Streak"/>
                <div className={classes.streakNumber}>
                    <DisplayText variant={TextVariant.s44reg}>{streak}</DisplayText>
                </div>
            </div>
            <DisplayText variant={TextVariant.s18reg}>Longest Streak</DisplayText>
        </div>
    );
}

type HostStreakProps = StreakProps & {
    names: string[]
    maxToShow: number
}

export function HostStreak({streak, names, maxToShow}:HostStreakProps) {
    const classes = useStyles();
    const theme:Theme = useTheme();

    return (
        <div className={classes.hostLongestStreak}>
            <div className={classes.streak}>
                <img className={classes.streakImage} src={theme.accessoryPanel.dashBoard.streak.fireSVGPath} alt="Streak"/>
                <div className={classes.streakNumber}>
                    <DisplayText variant={TextVariant.s44reg}>{streak}</DisplayText>
                </div>
            </div>
            <DisplayText variant={TextVariant.s18reg} className={classes.hostTitle}>LONGEST STREAK</DisplayText>
            <div className={classes.playerNames}>
                {names.slice(0,maxToShow).map((name, index) => <HostPlayerDisplay name={name} key={index}/>)}
                <HostViewAll number={streak} names={names} maxToShow={maxToShow} type={ViewAllType.Streak}/>
            </div>
        </div>
    );
}